import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { CarvanaButton } from '@carvana/purchase-styles';
import * as sc from './oos-delivery-modal-styles';

export const OOSDeliveryModal = (props) => {
  const {
    registrationState,
    deliveryState,
    isAddressVerificationV3,
    onUpdateDelivery,
    homeAddress,
    deliveryAddress,
  } = props;

  const { trackEvent } = useContext(AnalyticsContext);
  useEffect(() => {
    trackEvent('v3_out_of_state_delivery_modal_displayed', {
      registrationState: registrationState,
      deliveryState: deliveryState,
      homeAddress: homeAddress ? { state: homeAddress.state, zip: homeAddress.zip } : null,
      deliveryAddress: deliveryAddress ? { state: deliveryAddress.state, zip: deliveryAddress.zip } : null
    });
  }, []);

  return (
    <sc.Wrapper>
    <sc.AlertIcon />
      <sc.Copy>
        {`You let us know that you wanted to register your vehicle in ${registrationState}, but wish to deliver it to ${deliveryState}`}<br />
          <strong>{`However, ${registrationState} requires your vehicle to be present at the time of registration.`}</strong><br />
        Please update your home or delivery address to ensure the smoothest registration process.
      </sc.Copy>
      <CarvanaButton
        buttonStyles={sc.buttonStyles}
        onClick={
          e => {
            e.preventDefault();
            onUpdateDelivery();
          }
        }
        text='OK'
      />
  </sc.Wrapper>
  )
};

OOSDeliveryModal.propTypes = {
  registrationState: PropTypes.string.isRequired,
  deliveryState: PropTypes.string.isRequired,
  onUpdateDelivery: PropTypes.func.isRequired,
  isAddressVerificationV3: PropTypes.bool,
  homeAddress: PropTypes.object,
  deliveryAddress: PropTypes.object,
};

export default OOSDeliveryModal;
